import { apiConstants } from "../../utils/apiConstants";
import { apiTypes } from "../../utils/apiTypes";
import apiRequestType from "../apiRequestType";
import { getAxiosCancelToken } from "../../utils/getAxiosCancelToken";

let cancelToken;
const getYoutubeVideos = (searchTerm, pageNum, pageSize) => {
  cancelToken = getAxiosCancelToken(cancelToken);
  return apiRequestType(
    apiTypes.GET,
    apiConstants.MANAGE.GET_YOUTUBE_VIDEOS(searchTerm, pageNum, pageSize),
    "",
    cancelToken
  );
};

export default getYoutubeVideos;
